// extracted by mini-css-extract-plugin
module.exports = {"offerCard":"styles_offerCard__99vTR"};